import React from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
    DashboardIcon,
    DatabaseIcon,
    SchemaIcon,
    AIIcon,
    QueryIcon,
    NLPIcon,
    APIIcon,
    ReportIcon,
    SettingsIcon,
    SkillIcon
} from '../ui/Icons';

export const Sidebar = ({ isCollapsed, onToggle }) => {
    const { t } = useTranslation('layout');
    const navItems = [
        { to: '/', icon: DashboardIcon, label: t('nav.dashboard') },
        { to: '/database-connection', icon: DatabaseIcon, label: t('nav.databaseConnection') },
        { to: '/schema-analysis', icon: SchemaIcon, label: t('nav.schemaAnalysis') },
        { to: '/agents', icon: AIIcon, label: t('nav.aiAgents') },
        { to: '/skills', icon: SkillIcon, label: t('nav.skills') },
        { to: '/insight-query', icon: QueryIcon, label: t('nav.queryGenerator') },
        { to: '/query-generator', icon: NLPIcon, label: t('nav.nlpQueryGenerator') },
        { to: '/reports', icon: ReportIcon, label: t('nav.reports') },
        { to: '/api-endpoints', icon: APIIcon, label: t('nav.apiEndpoints') },

        { to: '/database-understanding', icon: SettingsIcon, label: t('nav.databaseUnderstanding') },
    ];

    return (
        <div className={`${isCollapsed ? 'w-16' : 'w-64'} bg-white border-r border-gray-200 h-[calc(100vh-4rem)] fixed left-0 top-16 transition-all duration-300 flex flex-col z-20`}>
            <nav className="px-3 py-4 space-y-1 flex-1 overflow-y-auto">
                {navItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={({ isActive }) =>
                            `flex items-center ${isCollapsed ? 'justify-center px-2' : 'space-x-3 px-3'} py-[0.75rem] rounded-lg transition-colors ${isActive
                                ? 'bg-primary-50 text-primary-600'
                                : 'text-gray-600 hover:bg-gray-100'
                            }`
                        }
                        title={isCollapsed ? item.label : undefined}
                    >
                        <item.icon className="w-[18px] h-[18px] flex-shrink-0" />
                        {!isCollapsed && (
                            <span className="font-medium text-sm">{item.label}</span>
                        )}
                    </NavLink>
                ))}
            </nav>

            <div className="px-3 py-2 border-t border-gray-100">
                <button
                    onClick={onToggle}
                    className={`w-full flex items-center ${isCollapsed ? 'justify-center' : 'px-4 gap-2'} py-3 text-[#64748B] hover:text-primary-600 transition-colors group`}
                    title={isCollapsed ? t('sidebar.expandSidebar') : t('sidebar.collapseSidebar')}
                >
                    {isCollapsed ? (
                        <ChevronsRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
                    ) : (
                        <>
                            <ChevronsLeft className="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" />
                            <span className="font-bold text-sm tracking-tight">{t('sidebar.collapseSidebar')}</span>
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};
